import { Modal } from "@mui/material";
import React, { useState } from "react";

const EditTableDataModal = ({
  dataProps,
  isOpen,
  onUpdateTableDoc,
  onClose,
}) => {
  const { tableContent, id } = dataProps;

  const [jsonInput, setJsonInput] = useState(
    tableContent ? JSON.stringify(tableContent) : ""
  );
  const [tableData, setTableData] = useState(tableContent ?? []);

  // Handle input change in textarea
  const handleInputChange = (e) => {
    setJsonInput(e.target.value);
  };

  // Handle table data update
  const handleUpdateTable = () => {
    try {
      const parsedData = customParseJson(jsonInput);
      setTableData(parsedData);
    } catch (error) {
      alert("Invalid JSON format. Please check the syntax.");
    }
  };

  const handleUpdateTableDoc = () => {
    try {
      const parsedData = customParseJson(jsonInput);
      //setTableData(parsedData);
      onUpdateTableDoc(parsedData);
    } catch (error) {
      alert("Invalid JSON format. Please check the syntax.");
    }
  };

  // Custom parsing to convert non-standard JSON into valid JSON
  const customParseJson = (input) => {
    try {
      // Replacing the non-quoted keys with quotes to make it valid JSON
      const validJson = input.replace(/(\w+):/g, '"$1":');
      return JSON.parse(validJson);
    } catch (error) {
      throw new Error("Invalid JSON format");
    }
  };

  // Render the table headers based on JSON keys
  const renderTableHeaders = () => {
    if (tableData.length === 0) return null;
    const headers = Object.keys(tableData[0]);
    return (
      <thead>
        <tr>
          {headers.map((header, index) => (
            <th key={index}>{header}</th>
          ))}
        </tr>
      </thead>
    );
  };

  // Render the table rows based on the data
  const renderTableRows = () => {
    return (
      <tbody>
        {tableData.map((row, rowIndex) => (
          <tr key={rowIndex}>
            {Object.values(row).map((value, colIndex) => (
              <td key={colIndex}>{value}</td>
            ))}
          </tr>
        ))}
      </tbody>
    );
  };

  return (
    <Modal open={isOpen} onClose={onClose}>
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          padding: "10px",
          transform: "translate(-50%, -50%)",
          // width: 400,
          background: "white",
          border: "2px solid #000",
          boxShadow: 24,
          p: 4,
        }}
      >
        <h3>JSON Table Builder</h3>
        <textarea
          style={{ width: "600px", padding: "5px" }}
          value={jsonInput}
          onChange={handleInputChange}
          rows="10"
          cols="50"
          placeholder="Enter JSON data here"
        />
        <br />
        <button onClick={handleUpdateTable}>Update Table</button>
        <button onClick={handleUpdateTableDoc}>Update Table Doc</button>
        <table border="1" style={{ marginTop: "20px", width: "100%" }}>
          {renderTableHeaders()}
          {/* {renderTableRows()} */}
        </table>
      </div>
    </Modal>
  );
};

export default EditTableDataModal;
